export { RESOURCE_NAME } from '@esentai/core/features/productView/consts';
import { ROUTE_PATH as CATEGORIES_PATH } from '@/features/productsCategoryPage/consts';

export const ROUTE_PATH = `${CATEGORIES_PATH}/:categoryId`;

export const FEATURE_NAME = 'productsViewPage';
